export default __webpack_public_path__ + "static/media/sunrise.6d48da50.png";